import { getUrlConfigVideoType } from '../base/play-helper';
import { KeySystems } from '../drm';
import { DRM_TYPE } from '../enums';
/**
 * 通过urlConfig计算对应Metadata
 * @param urlConfig
 */
export function createMetadata(urlConfig) {
    var metadata = {
        urlConfig: urlConfig,
        videoType: getUrlConfigVideoType(urlConfig),
        drmType: getDrmType(urlConfig),
        vcodec: urlConfig === null || urlConfig === void 0 ? void 0 : urlConfig.vcodec,
    };
    return metadata;
}
/**
 * 通过urlConfig检查当前的加密类型，以便于选择对应内核
 */
export function getDrmType(urlConfig) {
    var _a;
    // 如果带有chacha参数，则是自研加密
    if (urlConfig === null || urlConfig === void 0 ? void 0 : urlConfig.chachaParam) {
        return DRM_TYPE.CHACHA;
    }
    var keySystem = (_a = urlConfig === null || urlConfig === void 0 ? void 0 : urlConfig.drmConfig) === null || _a === void 0 ? void 0 : _a.keySystem;
    // KeySystems包含FairPlay
    if ([KeySystems.FairPlay, KeySystems.FairPlayWebKit].includes(keySystem)) {
        return DRM_TYPE.FAIRPLAY;
    }
    // KeySystems包含Widevine
    if (KeySystems.Widevine === keySystem) {
        return DRM_TYPE.WIDEVINE;
    }
    return DRM_TYPE.NONE;
}
